import React, { useState, useEffect } from 'react'
import FormularioLogin from '../componentesAdmin/login/formulario_login.js'
import axios from 'axios'
import Cookies from 'universal-cookie'
//import { useNavigate } from 'react-router-dom';
import { useNavigate } from "react-router-dom";


const Login = ({ _config }) => {

	//const {baseUrl, titulo, sede} = _config._config
	const baseUrl = process.env.REACT_APP_BASE_URL
	const titulo = "Blue Moon Admin App"
	const sede = "Admin App"

	//estados:
	const baseUrlUsers = baseUrl + 'apibluemoon/usuarios/login_web.php';
	const cookies = new Cookies()
	const [form, setForm] = useState({ usuario: '', clave: '' })
	const [errorForm, setErrorForm] = useState('')
	const [errors, setErrors] = useState({ usuario: '', clave: '' })
	const [isSubmitting, setIsSubmitting] = useState(false)
	//trae información data api usuarios
	//const {loading, data, error} = useConsultaDatos(baseUrl);
	//funcion para navegar entre paginas
	//const history = useHistory();
	//const navigate = useNavigate();
	const navigate = useNavigate();


	//función click
	const onSubmit = async e => {
		e.preventDefault()

		const usuario = form.usuario.trim()
		const clave = form.clave
		const nuevosErrores = {
			usuario: usuario === '' ? 'Ingresa tu usuario.' : '',
			clave: clave.trim() === '' ? 'Ingresa tu contraseña.' : ''
		}

		setErrors(nuevosErrores)
		setErrorForm('')

		if (nuevosErrores.usuario || nuevosErrores.clave) return

		try {
			setIsSubmitting(true)
			const { data } = await axios.post(baseUrlUsers, { usuario, clave })
			const respuesta = data.user

			cookies.set('id', respuesta.id, { path: "/" })
			cookies.set('nombre', respuesta.nombre, { path: "/" })
			cookies.set('roll', respuesta.roll, { path: "/" })
			cookies.set('usuario', respuesta.usuario, { path: "/" })
			cookies.set('nombre', respuesta.nombre, { path: "/" })
			navigate('/Admin');
		} catch (error) {
			const respuestaError = error?.response?.data
			const campo = respuestaError?.field
			const mensaje = respuestaError?.message || 'No fue posible iniciar sesion.'

			setErrorForm(mensaje)
			setErrors({
				usuario: campo === 'usuario' ? mensaje : '',
				clave: campo === 'clave' ? mensaje : ''
			})
		} finally {
			setIsSubmitting(false)
		}
	}

	//función escucha form
	const onChange = e => {
		setErrorForm('')
		setErrors(prev => ({ ...prev, [e.target.name]: '' }))
		setForm({ ...form, [e.target.name]: e.target.value })
	}

	useEffect(() => {
		document.title = "Iniciar sesión - " + titulo
		if (cookies.get('usuario')) {
			navigate("../admin")
			console.log('cookie', cookies.get('usuario'))
			//history.push("../admin");
			//alert('correcto')
		} else {
			console.log('no tiene cokkies')
		}
	}, [])

	return (
		<div>
			<FormularioLogin
				onChange={onChange}
				form={form}
				onSubmit={onSubmit}
				errorForm={errorForm}
				sede={sede}
				errors={errors}
				isSubmitting={isSubmitting} />
		</div>
	)
}



export default Login
